// src/components/Navbar/index.js
import VideoSection from './VideoSection';
export default VideoSection;
